<template>
  <div class="min-h-screen bg-gray-50">
    <!-- Sidebar -->
    <Sidebar />
    
    <!-- Main content with margin for fixed sidebar -->
    <div class="ml-72">
      <!-- Page content -->
      <main class="p-6 w-full">
        <slot />
      </main>
    </div>
  </div>
</template>

<script>
import Sidebar from './Sidebar.vue'

export default {
  name: 'DoctorLayout',
  components: {
    Sidebar
  }
}
</script>

<style scoped>
/* Responsive adjustments */
@media (max-width: 768px) {
  /* Hide sidebar on mobile or adjust as needed */
}
</style> 
 